<template>
  <!-- 购物车 dialog -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      class="cart-dialog"
      :before-close="beforeClose"
      @closed="handlerClose"
      width="800px"
      append-to-body
    >
      <div class="el-row">
        <div class="el-col row-left">
          <!-- 商品图片 -->
          <img
            :src="
              goodsDetail.background +
              '?x-oss-process=image/resize,m_lfit,h_400,w_400&d=400x400'
            "
            alt="goods"
            class="goodsImg"
          />
          <!-- 告罄图片 -->
          <!-- <img :src="soldoutUrl+'?x-oss-process=image/resize,m_lfit,h_122,w_47&d=122x47'" alt="soldout" class="soldout" v-show="(!curSpec.qouta && !curSpec.num) || (goodsDetail.isSeckill && !curSpec.goods.num)" /> -->
          <!-- bbd -->
          <div
            :class="[
              'best-befor',
              { blue: curSpec.bbd || (curSpec.goods && curSpec.goods.bbd) },
            ]"
            v-show="
              curSpec.bbd ||
              curSpec.expiration_date ||
              (curSpec.goods &&
                (curSpec.goods.bbd || curSpec.goods.expiration_date))
            "
          >
            Best Before <br />
            {{
              formBBD(
                curSpec.bbd ||
                  curSpec.expiration_date ||
                  (curSpec.goods &&
                    (curSpec.goods.bbd || curSpec.goods.expiration_date))
              )
            }}
          </div>
        </div>
        <div class="row-right">
          <div class="right-title">
            <span
              class="tag color-F33026"
              v-if="
                (([2, 4, 23, 24].includes(curSpec.type) || curSpec.special) &&
                  (curSpec.external_text ||
                    (curSpec.agree && curSpec.agree.cn_content))) ||
                (goodsDetail.isSeckill &&
                  curSpec.total_num - curSpec.sale_num &&
                  goodsDetail.status === 2)
              "
            >
              <template>
                <span v-if="[23].includes(curSpec.type)">{{
                  `${curSpec.external.rule.goods_num}+${curSpec.external.rule.gift_num}`
                }}</span>
                {{
                  curSpec.external_text ||
                  (curSpec.agree && curSpec.agree.cn_content)
                }}
              </template>
            </span>
            <span
              class="tag color-97C8EB"
              v-else-if="[3].includes(curSpec.type) || goodsDetail.agent === 1"
              >{{
                curSpec.external_text ||
                (curSpec.agree && curSpec.agree.cn_content)
              }}</span
            >
            <span class="name">{{ goodsDetail.cn_name }}</span>
          </div>
          <div class="fleprices">
            <!-- <span
              class="fonswas"
              v-html="'€' + formPrice(SelectedItem.spec_price)"
            ></span> -->
            <span
              class="original-price"
              v-html="specPicepents(SelectedItem.spec_price)"
            ></span>
            <span
              class="original_toflex"
              v-html="specPice(SelectedItem.spec_price)"
            >
            </span>
          </div>
          <div class="content">
            <div
              class="popup-goods-spec"
              v-for="(items, indexs) in newGoods.spec_data || newGoods.goods"
              :key="items.spec_id"
            >
              <div class="specNames">{{ items.spec_name }}</div>
              <div
                v-for="itemchild in items.spec_value"
                :key="itemchild.spec_value_id"
                :class="[
                  itemchild.checkBox
                    ? 'popup-spec-active'
                    : 'popup-spec-default',
                  'popup-goods-spec-sku',
                ]"
                @click="handleSelectSku(indexs, itemchild.spec_value_id)"
              >
                <div>{{ itemchild.spec_value_name }}</div>
              </div>
            </div>
            <div class="quantity">{{ $t("数量") }}</div>
            <el-input-number
              class="input-number"
              style="border-radius: 0px"
              v-model="qty"
              :min="1"
              :max="SelectedItem.num ? SelectedItem.num : maxNum"
            ></el-input-number>
          </div>
          <div class="popup-goods-bottom">
            <div>
              <div
                v-if="!newGoods.checked_goods || goodsDetail.checked_goods"
                v-bind:class="[
                  SelectedItem.num > 0 ? 'popup-btn' : 'popupnot-btn',
                ]"
                @click="addCart(SelectedItem.sku, 1)"
                :disabled="SelectedItem.num == 0"
              >
                {{
                  SelectedItem.num > 0
                    ? isCart
                      ? $t("确认")
                      : $t("add_cart")
                    : $t("已售罄")
                }}
              </div>
              <div
                v-else
                class="popup-btn"
                @click="changeCart(SelectedItem, qty)"
              >
                {{ $t("确认") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="successVisible"
      class="cart-dialog"
      :before-close="successClose"
      @closed="successClose"
      width="320px"
      append-to-body
    >
      <div
        class="flexSuccess"
        style="
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
        "
      >
        <img
          src="/images/newpcImg/successIcon.png"
          class="successIcon"
          alt=""
        />
        <div class="addcartText">{{ $t("已添加到购物车中") }}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import { store } from "../header";
import formPrice from "./formPrice";
import handCevent from './cEvent'
// import soldoutUrl from '../../images/soldout.png'
import { loadLanguageAsync } from "../lib/i18n";
loadLanguageAsync("hot");
export default {
  data() {
    return {
      successVisible: false,
      // soldoutUrl: soldoutUrl,
      formPrice: formPrice,
      qty: 1,
      // 加入购物车 被选中的规格选项
      curSpec: {},
      loading: null,
      btnLoading: false,
      is_user: null,
      newGoods: {},
      change: 0,
      SelectedItem: "",
    };
  },
  props: {
    goodsDetail: Object,
    dialogVisible: Boolean,
    addCartLoading: Boolean,
    isCart: Boolean,
  },
  watch: {
    addCartLoading: function (newVal) {
      if (newVal) {
        this.loading = Loading.service({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.7)",
          target: document.querySelector(".cart-dialog .el-dialog"),
        });
      } else {
        this.loading && this.loading.close();
      }
    },
    dialogVisible: {
      handler() {
        if (this.goodsDetail.checked_goods) {
          this.goodsDetail.goods.forEach((es) => {
            if (es.sku == this.goodsDetail.checked_goods.sku) {
              es.spec.forEach((d) => {
                this.goodsDetail.spec_data.forEach((a) => {
                  if (d.spec_id == a.spec_id) {
                    a.spec_value.forEach((as) => {
                      if (as.spec_value_id == d.spec_value_id) {
                        as.checkBox = true;
                        // console.log(as,'asas');
                      }
                    });
                  }
                });
              });
            }
          });
        } else {
          this.goodsDetail.spec_data.forEach((e) => {
            e.spec_value[0].checkBox = true;
          });
        }
        this.change = this.change + 1;
        this.newGoods = JSON.stringify(this.goodsDetail);
        this.newGoods = JSON.parse(this.newGoods);
      },
    },
    change: {
      handler(newValue, oldValue) {
        if (newValue) {
          const spec_idList = [];
          this.newGoods.spec_data.forEach((e) => {
            e.spec_value.forEach((es) => {
              if (es.checkBox) {
                spec_idList.push(es.spec_value_id);
              }
            });
          });
          this.newGoods.goods.forEach((item) => {
            const list = [];
            item.spec.forEach((a) => {
              if (spec_idList.indexOf(a.spec_value_id) !== -1) {
                list.push(a.spec_value_id);
              }
            });
            if (JSON.stringify(list) == JSON.stringify(spec_idList)) {
              this.SelectedItem = item;
            }
          });
          // console.log(this.SelectedItem, "当前", this.curSpec);
          this.curSpec.sku = this.SelectedItem.sku;
          this.curSpec.num = this.SelectedItem.num;
          // console.log(this.SelectedItem, "SelectedItem", this.newGoods);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    specPicepents(spec_price) {
      return spec_price
        ? `${
            spec_price
              ? "€" + spec_price.slice(0, spec_price.length - 2)
              : "€" + spec_price
          }`
        : "";
    },
    specPice(spec_price) {
      return spec_price ? spec_price.slice(-2) : "";
    },
    successClose() {
      this.successVisible = false;
    },
    changeCart(SelectedItem, qty) {
      this.$json
        .put(`cart/api/${this.goodsDetail.car_id}`, {
          sku: SelectedItem.sku,
          qty,
        })
        .then((res) => {
          if (res.ret) {
            this.qty = "";
            this.SelectedItem = {};
            this.curSpec = {};
            this.$emit("getData");
            this.$emit("dialog-visible-show", false);
          }
        });
    },
    // 选择sku
    handleSelectSku(index, spec_id) {
      this.change = this.change + 1;
      this.newGoods.spec_data[index].spec_value.forEach((es) => {
        if (es.spec_value_id == spec_id) {
          es.checkBox = true;
        } else {
          es.checkBox = false;
        }
      });
    },
    formBBD(val) {
      if (!val || val.indexOf("/") !== -1) return val;
      let date = val.split("-");
      return `${date[2]}/${date[1]}/${date[0]}`;
    },
    beforeClose() {
      this.$emit("dialog-visible-show", false);
    },
    handlerClose() {
      this.qty = "";
      this.curSpec = {};
      this.$emit("input", false);
    },
    selectWeight(item) {
      this.curSpec = item;
    },
    gologin() {
      const route = window.location;
      const localLang = localStorage.getItem("localLang");
      let url = `${route.origin}${
        localLang != "en" ? "/" + localLang : ""
      }/login`;
      route.href = url;
    },
    addCart(sku, num) {
      if (this.SelectedItem.num <= 0) {
        return this.$message.info(this.$t("库存不足"));
      }
      this.btnLoading = true;
      store.getters.computedLoginPromise.finally(() => {
        if (store.state.isLogin) {
          if (this.isCart) {
            this.$json
              .put(`cart/api/${this.goodsDetail.car_id}`, {
                qty: this.qty,
                sku: sku,
              })
              .then((reso) => {
                // console.log("加入了购物车", sku, localStorage.getItem("CID"));
                store.commit("CART_CHANGE", store.state.cartCount + this.qty);
                if (reso.ret) {
                  this.$emit("getData");
                  this.successVisible = true;
                  setTimeout(() => {
                    this.successVisible = false;
                  }, 1500);
                }
                this.beforeClose();
              });
          } else {
            this.$json
              .post("cart/api", {
                qty: this.qty,
                sku: sku,
              })
              .then((res) => {
                // console.log("加入了购物车", sku, localStorage.getItem("CID"));
                store.commit("CART_CHANGE", store.state.cartCount + this.qty);
                if (res.ret) {
                  // this.$message({
                  //   message: res.msg,
                  //   type: "success",
                  // });
                  this.successVisible = true;
                  setTimeout(() => {
                    this.successVisible = false;
                  }, 1500);
                }
                var cpms = [
                  {
                    key: "qty",
                    value: this.qty,
                  },
                  {
                    key: "sku",
                    value: sku,
                  },
                ];
                handCevent("add_to_cart", cpms);
                this.beforeClose();
              })
              .finally(() => (this.btnLoading = false));
          }
        } else {
          this.gologin();
          this.btnLoading = false;
        }
      });
    },
  },
  computed: {
    lang() {
      return localStorage.getItem("localLang");
    },
    // 当前商品还能购买多少个
    maxNum() {
      if (store.state.isLogin) {
        return this.curSpec.qouta || this.curSpec.num;
      } else {
        let curGoods = store.state.cartList[this.curSpec.sku];
        if (!curGoods) return this.curSpec.qouta || this.curSpec.num;
        if (curGoods.qouta) {
          return curGoods.qouta - curGoods.qty;
        } else {
          return curGoods.num - curGoods.qty;
        }
      }
    },
  },
};
</script>
<style>
.el-loading-spinner i {
  color: #ff7802;
}
.el-loading-spinner .el-loading-text {
  color: #ff7802 !important;
}
</style>
<style lang="scss" scoped>
/deep/ .el-icon-plus:before {
  color: #999;
}
/deep/ .el-icon-minus:before {
  color: #999;
}
.input-number {
  width: 100px !important;
  font-weight: 400;
  margin-top: 10px;
  color: #3d3d3d;
  height: 30px;
  line-height: 28px !important;
  /deep/ .el-input__inner {
    height: 31px;
    font-size: 0.5385rem !important;
    border: none !important;
    padding: 0;
    font-weight: 400;
    color: #3d3d3d;
    border: 1px solid #cacaca !important;
  }
  /deep/ .el-input-number {
    line-height: 28px !important;
  }
  /deep/ .el-input-number__decrease {
    background: #fff !important;
    border-right: 0px;
  }
  /deep/ .el-input-number__increase {
    background: #fff !important;
    border-left: 0px;
  }
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 200px);
  max-width: calc(100% - 30px);
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.flexSuccess {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.addcartText {
  font-size: 0.6154rem;
  font-weight: 400;
  color: #333;
  margin-top: 0.7692rem;
}
.successIcon {
  width: 1.5385rem;
  height: 1.5385rem;
}
.quantity {
  margin-top: 1.5385rem;
  font-size: 0.6154rem;
  font-weight: 500;
  color: #333;
}
.popup-goods-bottom {
  width: 100%;
  height: 50px;
  z-index: 3001;
  .popup-btn {
    cursor: pointer;
    background-color: #ff7802;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 50px;
    width: 100%;
    border-radius: 0px;
    border: none;
  }
  .popupnot-btn {
    cursor: pointer;
    background-color: #999;
    color: #fff;
    font-size: 0.6154rem;
    text-align: center;
    line-height: 50px;
    width: 100%;
    border-radius: 0px;
    border: none;
  }
}
.popup-goods-spec {
  overflow: hidden;
  line-height: 1.6;
  .specNames {
    font-size: 0.6154rem;
    font-weight: 500;
    color: #333;
    margin-top: 0.7692rem;
  }
  .popup-goods-spec-sku {
    padding: 0 0.3077rem;
    margin: 0.3846rem 0.3846rem 0 0;
    float: left;
    height: 1.1538rem !important;
    line-height: 1.1538rem !important;
    position: relative;
    cursor: pointer;
  }
  .popup-spec-active {
    // border: 1px solid $popup-spec-active-text-color;
    // background: #fa7e24;
    // border-radius: 18px;
    // color: $popup-spec-active-text-color;
    border: 1px solid #ff7802;
    color: #ff7802;
    font-size: 0.5385rem;
    font-weight: 500;
  }
  .popup-spec-default {
    // border: 1px solid $popup-spec-default-text-color;
    // color: $popup-spec-default-text-color;
    background: #ffff;
    // border-radius: 18px;
    border: 1px solid #cacaca;
    font-size: 0.5385rem;
    font-weight: 400;
    color: #3d3d3d;
  }
}
.fleprices {
  display: flex;
  align-items: baseline;
  padding: 0.7692rem 0 0 0;
  .original-price {
    font-size: 0.7692rem;
    font-weight: bold;
    color: #ff7802;
  }
  .original_toflex {
    font-size: 0.5385rem;
    font-weight: bold;
    color: #ff7802;
  }
  .tofiexas {
    font-size: 0.5385rem;
    font-weight: bold;
    color: #ff7802;
  }
  .fonswas {
    font-size: 0.7692rem;
    font-weight: bold;
    color: #ff7802;
  }
}
.cart-dialog {
  .el-row {
    min-height: 300px;
    padding: 0 0.7692rem 0.7692rem 0.7692rem;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    .row-left {
      // width: 45.83333%;
      text-align: center;
      // height: 300px;
      position: relative;
      .goodsImg {
        width: 240px;
        height: 240px;
        object-fit: contain;
      }
      // img[alt="goods"] {
      //   width: 90%;
      //   height: 90%;
      //   position: absolute;
      //   top: 50%;
      //   transform: translateY(-50%);
      //   left: 0;
      // }
      .soldout[alt="soldout"] {
        position: absolute;
        top: 50%;
        left: 45%;
        transform: translate(-50%, -50%);
      }
      .best-befor {
        position: absolute;
        bottom: 10px;
        left: 45%;
        transform: translateX(-50%);
        padding: 3px 10px;
        color: #fff;
        border-radius: 6px;
        background: #b1b1b1;
        font-size: 14px;
      }
      .blue {
        background: #97c8eb;
      }
    }
    .row-right {
      flex: 1;
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      min-height: 300px;
      .right-title {
        font-size: 0.7692rem;
        font-weight: bold;
        color: #333;
        display: flex;
        column-gap: 5px;
        align-items: center;
        .tag {
          color: #fff;
          padding: 5px;
          font-size: 8px;
          border-radius: 5px;
        }
        .color-F33026 {
          background-color: #f33026;
        }
        .color-97C8EB {
          background-color: #97c8eb;
        }
        .name {
          font-size: 0.6154rem;
          font-weight: bold;
          color: #333;
        }
      }
      .el-button {
        width: 150px;
        color: #fff;
        background: #169bd5;
      }
      .content {
        display: flex;
        flex-direction: column;
        // row-gap: 10px;
        color: #999;
        font-size: 14px;
        // padding: 0.7692rem 0;
        margin: 0.7692rem 0;
        border-top: solid 1px #e6e5e5;
        // border-bottom: solid 1px #E6E5E5;
        .wegroup {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          align-items: center;
          .limit {
            color: #f33026;
          }
          .cart-weight {
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            position: relative;
            padding: 8px 15px 8px 10px;
            cursor: pointer;
            border-radius: 5px;
            border: 1px solid #999;
            color: #999;
          }
          .cart-weight.is-active {
            border-color: #019ae0;
            color: #019ae0;
          }
          .cart-weight.is-active::after {
            content: "";
            display: block;
            width: 16px;
            height: 16px;
            position: absolute;
            top: 0;
            right: 0;
            background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAwElEQVQ4T2NkoBAwUqifgf4GiM6+soDhP+P/12naiSDXk+QCkGZGBsZ4qLcbX6VqNxBtALLm////X/zNyu3wIVHxA9wA0VlXDUAmv07TvoAesLg0w70A1sz4fz9Y439GR2RD8GlGMuDKBEZGxnywfob/H2CGENKMEogoihn+f2D8z3iAgZEhAGwokp/RvYcSiGihDPERHs1Yo5EYZyO7Ams0QhILgwEsqvAld5zpQGD+fQFQPBPKK0QnJFwGUWwAAEuodRHRsPpWAAAAAElFTkSuQmCC");
          }
        }
        .price {
          .product-number {
            color: #f33026;
            font-size: 16px;
          }
          .red {
            color: #f33026;
            font-weight: bold;
          }
          .price-large {
            font-size: 20px;
            span {
              font-size: 16px;
            }
          }
          .del-price {
            font-size: 16px;
            text-decoration: line-through;
          }
        }
      }
      .add-cart.is-disabled {
        background: #99a;
        cursor: auto;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// resources/js/components/CartDialog.vue